<template>
  <div class="">
    <Select v-model="projectFid" class="select-width mb16" placeholder="请选择项目" @on-change="projectChange">
      <Option value="">请选择</Option>
      <Option v-for="(item,index) in projectList" :key="'project'+index" :value="item.value">{{item.text}}</Option>
    </Select>
    <div>
      <template v-for="item in scheduleConfig">
        <span>{{item.scheduleConfigName}}</span>
        <span>:</span>
        <span>{{item.startTime}}</span>
        <span>--</span>
        <span style="margin-right: 20px">{{item.endTime}}</span>
      </template>
    </div>
    <div v-if="projectFid && scheduleConfig.length==0">暂无班次设置信息</div>
    <div class="align-center mb16">
      <Select class="select" v-model="year" @on-change="changeDate">
        <Option v-for="item in yearList" :value="item" :key="'year'+item">{{item}}</Option>
      </Select> 年
      <Select class="select" v-model="month" @on-change="changeDate">
        <Option v-for="item in monthList " :value="item" :key="'month'+item">{{item}}</Option>
      </Select> 月
      <Button class="doSchedule" type="primary" @click.stop="doSchedule"
              v-p="{api:'business/updateSchedule'}"
    >排班</Button>
    </div>
    <div class="schedule">
      <div class="weeks">
        <div class="week-item" v-for="item in weeks" :key="item">{{item}}</div>
      </div>
      <div class="no-data" v-if="dataList.length==0">请选择项目</div>
      <div class="date" v-for="(item,index) in pageData " :key="'page'+index">
        <template v-for="(item1) in item">
          <div :class="['date-item',{'blank':item1==0,'btn-primary111':item1.checked}]" v-if="item.length>0"
               @click.stop="clickDate(item1)">
            <div class="align-right">{{item1!==0?item1.scheduleDate:''}}</div>
            <div v-for="(item2,index2) in item1.scheduleList " :key="'keyB'+index2">
              <div>{{item2.scheduleConfigName}}</div>
              <div style="box-sizing: border-box;padding-left: 20px">
                <span v-for="item3 in item2.scheduleZoList" style="margin-right: 10px">{{item3.text}}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <pai-ban-modal :n="n" :planListOri="planList" :GOListOri="unPlanZos"
                   @updateSchedule="updateSchedule"></pai-ban-modal>
  </div>
</template>
<script>
  import PaiBanModal from './components/PaiBanModal'
  import {updateSchedule, getSchedule, getProjectZos, getScheduleConfig} from 'api/scheduleManage.js'
  import {getProjects} from "../../../../api/common";
  import {deepClone} from "../../../../utils/format";

  export default {
    name:'schedule1',
    components: {
      PaiBanModal
    },
    data() {
      return {
        weeks: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
        year: '',
        yearList: [],
        month: '',
        monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        dataList: [],
        n: 0,
        projectFid: '',
        today: '',
        zos: [],
        scheduleConfig: [],
        projectName: '',
        projectList: []
      }
    },
    computed: {
      planList() {   //传给排班模态框的排班数据
        if (this.checkedData.length == 1) {
          let list = this.checkedData[0].scheduleList
          if (!list || list.length == 0) {
            return this.scheduleConfig
          }
          else {
            return this.addAddition(list)
          }
        }
        if (this.checkedData.length > 1) {
          return this.scheduleConfig
        }
        return []
      },
      unPlanZos() {  //未排班管家
        if (this.zos.length == 0) {
          return []
        }
        var ret=[]
        this.zos.forEach(ele=>{
          let flag=false
          this.planList.forEach(ele1=>{
            ele1.scheduleZoList && ele1.scheduleZoList.forEach(ele2 => {
              if (ele.value == ele2.value) {
                flag = true
              }
            })
          })
          !flag && ret.push(ele)
        })
        return ret
      },
      checkedData() {
        return this.dataList.filter(ele => {
          return ele['checked']
        })
      },
      pageData() {
        if (this.dataList.length == 0) {
          return
        }
        var firstday = new Date(this.year, this.month - 1, 1)
        var index = firstday.getDay()
        var beforeAdd = Array(index).fill(0)
        this.dataList = beforeAdd.concat(this.dataList)
        return [
          this.dataList.slice(0, 7),
          this.dataList.slice(7, 14),
          this.dataList.slice(14, 21),
          this.dataList.slice(21, 28),
          this.fillEnd(this.dataList.slice(28, 35)),
          this.fillEnd(this.dataList.slice(35))
        ]
      }
      // dataList
    },
    methods: {
      changeDate(){
        if(!this.projectFid){
          this.$Message.info('请选择项目')
          return
        }
        this.getDataList()
      },
      makeDate(date) {
        let month = (this.month + '').length >= 2 ? this.month : ('0' + this.month)
        let date1 = (date + '').length >= 2 ? date : ('0' + date)
        return this.year + '-' + month + '-' + date1

      },
      makeScheduleDateList(list) {
        var ret = []
        this.checkedData.forEach(ele => {
          ret.push({
            'scheduleDate': this.makeDate(ele.scheduleDate),
            'scheduleList': list
          })
        })
        return ret
      },
      updateSchedule(list) {
        var params = {
          "projectFid": this.projectFid,
          "projectName": this.projectName,
          "scheduleDateList": this.makeScheduleDateList(list)
        }
        updateSchedule(params).then(res => {
          this.getDataList()  //更新页面数据
        })
      },
      addAddition(list) {
        var ret = deepClone(list)

        this.scheduleConfig.forEach(ele => {
          let ishas = false
          list.forEach(ele1 => {
            if (ele.scheduleConfigFid == ele1.scheduleConfigFid) {
              ishas = true
            }
          })
          !ishas && ret.push(ele)
        })

        //去除历史排班信息
        ret=ret.filter(ele=>{
            var isDead = true
            this.scheduleConfig.forEach(ele1 => {
              if (ele.scheduleConfigFid == ele1.scheduleConfigFid) {
                isDead = false
              }
            })
          return !isDead
        })
        return ret
      },

      projectChange() {
        if(this.projectFid==''){
          this.scheduleConfig=[]
          this.dataList=[]
          this.zos=[]
          return
        }
        this.getDataList()
        this.getZos()
        this.getScheduleConfig()
      },
      getScheduleConfig() {
        var params = {
          projectFid: this.projectFid,
          page: 1,
          limit: 10
        }
        getScheduleConfig(params).then(res => {
          if (res.data.rows.length == 0) {
            this.scheduleConfig = []
            return
          }
          var list = res.data.rows[0].scheduleConfigList
          list.forEach(ele => {
            ele['scheduleZoList'] = []
            ele['checked'] = false
          })
          this.scheduleConfig = list
          this.projectName = res.data.rows[0].projectName

        })
      },

      getZos() {
        let params = {
          projectFid: this.projectFid
        }
        getProjectZos(params).then(res => {
          this.zos = res.data
        })
      },
      getDataList() {
        var params = {
          projectFid: this.projectFid,
          scheduleDate: this.year + '-' + (this.month < 10 ? '0' + this.month : this.month)
        }
        getSchedule(params).then(res => {
          this.addCheckTag(res.data.scheduleDateList)
          this.dataList = res.data.scheduleDateList
        })
      },
      format(value) {
        return value.toString().length > 1 ? value : '0' + value
      },
      initYM() {
        var today = new Date()
        var year = today.getFullYear()
        var month = today.getMonth() + 1
        var day = today.getDate()
        this.month = month
        this.year = year
        this.yearList = [year - 1, year, year + 1, year + 2, year + 3, year + 4, year + 5]
        this.today = '' + year + this.format(month) + this.format(day)
      },
      doSchedule() {
        if (!this.projectFid) {
          this.$Message.info('请选择项目')
          return
        }
        if (this.scheduleConfig.length == 0) {
          this.$Message.info('请先设置班次信息')
          return
        }
        if (!this.checkedData || this.checkedData.length == 0) {
          this.$Message.info('请选择日期')
          return
        }
        this.n++
      },
      fillEnd(arr) {
        if (arr.length == 0) {
          return arr
        }
        return arr.concat(Array(7 - arr.length).fill(0))
      },
      clickDate(item) {
        if (item === 0) {
          return
        }
        var d1 = '' + this.year + this.format(this.month) + this.format(item.scheduleDate)
        if (Number(d1) < Number(this.today)) {
          this.$Message.info('当前日期不支持排班')
          return
        }
        item.checked = !item.checked
      },
      addCheckTag(list) {
        list.forEach(ele => {
          if (ele == 0) {
            return
          }
          ele['checked'] = false
          ele.scheduleList && ele.scheduleList.forEach(ele1 => {
            ele1['checked'] = false
          })
        })
      }
    },
    created() {
      this.initYM()
      getProjects().then(res => {
        this.projectList = res.data
        if(this.projectList.length==1){
          this.projectFid=this.projectList[0].value
          this.getDataList()
        }
      })

    }
  }
</script>
<style scoped>
  .align-right {
    text-align: right;
  }

  .select-width {
    width: 200px;
  }

  .schedule {
    font-weight: bold;
    position: relative;
  }

  .no-data {
    text-align: center;
    height: 60px;
    line-height: 60px;
    border: 1px solid rgb(210, 210, 210);

  }

  .doSchedule {
    margin-left: 60px;
  }

  .date-item {
    padding: 10px;
    height: 90px;
    /*background-color: rgb(240, 240, 240);*/
    box-sizing: border-box;
    flex: 1;
    border: 1px solid #DDDDDD;
    overflow: auto;
    margin-top: -1px;
    margin-left: -1px;
  }
  .date-item:first-child{
    margin-left: 0px;
  }

  .weeks, .date {
    display: flex;
    /*background-color: rgb(240,240,240);*/
  }

  .blank {
    background-color: rgb(250, 250, 250);
  }

  .week-item {
    background-color: #f9f9f9;
    flex: auto;
    line-height: 2.8;
    text-align: center;
    box-sizing: border-box;
    border: 1px solid #DDDDDD;
    border-bottom: none;
    margin-left: -1px;
  }
  .week-item:first-child{
    margin-left: 0px;
  }

  .select {
    margin: 0 10px;
    width: 100px;
    display: inline-block;
  }

  .align-center {
    text-align: center;
  }
  .btn-primary111{
    border: 1px solid #CFA868;
    z-index: 999;
  }
</style>
